import { SET_ACTIVE_TAB } from '../types/tab'

// set active tab
export function setActiveTab({ group, name }) {
  return {
    type: SET_ACTIVE_TAB,
    payload: { group, name },
  }
}
